import {
  ANSWER_QUESTION,
} from './actions';

function reducer(state, action) {
  switch (action.type) {
    case ANSWER_QUESTION:
      return {
        ...state,
        answers: {
          ...state.answers,
          [action.questionKey]: action.answer,
        },
      };
    default:
      return state;
  }
};

export default reducer;
